module.exports = __webpack_public_path__ + "img/security-section.a9a0b667.svg";